// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n0-1";
export var stateContainer = "_n0-0";